import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "colorProgress",
})
export class ColorProgressPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    value = Number(value);
    if (value < 70) {
      return `progress-status-1`;
    } else if (value < 90) {
      return `progress-status-2`;
    } else if (value < 100) {
      return `progress-status-3`;
    } else {
      return `progress-status-4`;
    }
  }
}
